import { MessageCircle, Instagram } from "lucide-react";
import { WHATSAPP_URL, COMPANY } from "@/api";

export const Footer = () => (
  <footer className="bg-[#1C1B1A] text-stone-400 py-14" data-testid="site-footer">
    <div className="max-w-[1400px] mx-auto px-6 md:px-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
      <div>
        <span className="font-serif text-3xl text-stone-100 tracking-tight">İnegöl <span className="text-wood-light">Mobilya</span></span>
        <p className="text-sm font-light mt-2">Doğal ahşap, el işçiliği, zamansız tasarım — Mardin.</p>
        <a
          href={`https://instagram.com/${COMPANY.instagram}`}
          target="_blank"
          rel="noopener noreferrer"
          className="mt-3 inline-flex items-center gap-2 text-xs font-semibold tracking-[0.15em] uppercase hover:text-stone-100 transition-colors duration-300"
          data-testid="footer-instagram-link"
        >
          <Instagram size={14} /> @{COMPANY.instagram}
        </a>
      </div>
      <div className="flex gap-8 text-xs font-semibold tracking-[0.2em] uppercase">
        <a href="#koleksiyon" className="link-underline hover:text-stone-100 transition-colors duration-300" data-testid="footer-link-koleksiyon">Koleksiyon</a>
        <a href="#manifesto" className="link-underline hover:text-stone-100 transition-colors duration-300" data-testid="footer-link-manifesto">Manifesto</a>
        <a href="#iletisim" className="link-underline hover:text-stone-100 transition-colors duration-300" data-testid="footer-link-iletisim">İletişim</a>
      </div>
      <p className="text-xs font-light">© 2026 İnegöl Mobilya — Mardin. Tüm hakları saklıdır.</p>
    </div>
  </footer>
);

export const WhatsAppFloat = () => (
  <a
    href={WHATSAPP_URL}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="WhatsApp"
    data-testid="whatsapp-float-button"
    className="fixed bottom-6 right-6 z-[60] flex h-14 w-14 items-center justify-center rounded-full bg-stone-900 text-stone-50 shadow-xl hover:bg-wood hover:scale-105 transition-all duration-300"
  >
    <MessageCircle size={22} />
  </a>
);
